import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIROrganization } from '../../../../models';

@Component({
  selector: 'app-organizations-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './organizations-section.component.html',
})
export class OrganizationsSectionComponent {
  readonly organizations = input.required<FHIROrganization[]>();

  getNIT(org: FHIROrganization): string {
    return (
      (org.identifier || []).find((id) =>
        (id.type?.coding || []).some(
          (c) => c.code?.toUpperCase() === 'NIT' || c.code?.toUpperCase() === 'TAX',
        ),
      )?.value || ''
    );
  }

  getCodigo(org: FHIROrganization): string {
    return (
      (org.identifier || []).find((id) =>
        (id.type?.coding || []).some(
          (c) => c.code?.toUpperCase() === 'CODIGOPRESTADOR' || c.code?.toUpperCase() === 'PRN',
        ),
      )?.value || ''
    );
  }

  getOrgType(org: FHIROrganization): string {
    return (
      org.type?.[0]?.coding?.[0]?.display ||
      org.type?.[0]?.coding?.[0]?.code ||
      org.type?.[0]?.text ||
      ''
    );
  }

  isIPS(org: FHIROrganization): boolean {
    const t = this.getOrgType(org).toUpperCase();
    return t.includes('IPS') || t.includes('PRESTADOR');
  }

  isEPS(org: FHIROrganization): boolean {
    const t = this.getOrgType(org).toUpperCase();
    return t.includes('EPS') || t.includes('ASEGURADOR');
  }

  getAddress(org: FHIROrganization): string {
    const addr = org.address?.[0];
    if (!addr) return '';
    return [addr.city, addr.state, addr.country].filter(Boolean).join(', ');
  }
}
